import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
} from 'reactstrap';

import AdminGroupEditMainEdit from './MainEdit';
import AdminGroupEditCapabilitiesEdit from './CapabilitiesEdit';
import AdminGroupEditMembersEdit from './MembersEdit';

class AdminGroupEditTabContent extends PureComponent {
  render() {
    const {
      groupId,
      activeTab,
    } = this.props;

    return (
      <TabContent activeTab={activeTab} className="settings-tab-content">
        <TabPane tabId="1">
          <AdminGroupEditMainEdit
            {...this.props}
          />
        </TabPane>
        <TabPane tabId="2">
          {groupId && (
            <AdminGroupEditCapabilitiesEdit
              {...this.props}
            />
          )}
        </TabPane>
        <TabPane tabId="3">
          {groupId && (
            <AdminGroupEditMembersEdit
              {...this.props}
            />
          )}
        </TabPane>
      </TabContent>
    );
  }
}

AdminGroupEditTabContent.propTypes = {
  group: PropTypes.object,
  groupId: PropTypes.string,
  activeTab: PropTypes.string.isRequired,
};

AdminGroupEditTabContent.defaultProps = {
  group: null,
  groupId: null,
};

export default AdminGroupEditTabContent;
